import { render, staticRenderFns } from "./HomePageCampusCard.vue?vue&type=template&id=bc1df574"
import script from "./HomePageCampusCard.vue?vue&type=script&lang=js"
export * from "./HomePageCampusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DiplomesHomePage: require('/home/apprentissage-montpellier/www/prod/AM-frontend/components/DiplomesHomePage.vue').default})
